var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',[_vm._v("您正在申請")]),_c('h1',[_vm._v("百利好國際之交易賬戶")]),_c('div',[_vm._v("欲申請百利好國際有限公司之交易賬戶，您必須年滿十八歲，並同意申請過程之條款。")])])}]

export { render, staticRenderFns }